import RequestAbstract from "../abstract";

export default class CascadeRules extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-cascade-rules';
    }

}
